<template>
  <div
    class="BreadcrumbsNav py-gr-half-5 leading-gr-6 bg-white/50 dark:bg-black/50"
    v-if="hasCrumbs"
  >
    <div class="container">
      <nav class="flex items-center space-x-gr-3">
        <div v-for="(crumb, index) in crumbs" class="max-w-gr-11 truncate text-xs">
          <i v-if="index" class="fa fa-fw fa-chevron-right mr-gr-3 opacity-20"></i>
          <component
            :is="crumb.href ? 'subdomain-link' : 'span'"
            :href="crumb.href"
            :class="{ link: crumb.href }"
            >{{ crumb.title }}</component
          >
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BreadcrumbsNav',

    data() {
      return {
        book: this.$page.props.book,
        promo: this.$page.props.promo,
        isEditMode: this.$page.props.mode?.indexOf('edit') !== -1,
        isNewMode: this.$page.props.mode?.indexOf('new') !== -1,
      };
    },

    computed: {
      hasCrumbs() {
        return this.crumbs.length;
      },

      hasBookParams() {
        return route() && route()?.params?.b;
      },

      crumbs() {
        let crumbs = [];
        let hasBook = !!this.book;
        let hasPromo = !!this.promo;
        let showBookLink = hasPromo || this.hasBookParams || this.isEditMode;
        let showPromoLink = hasPromo && !this.isEditMode;
        let showPromoBackLink = hasPromo && this.isEditMode;

        if (hasBook) {
          crumbs.push({
            href: route('admin.books'),
            title: 'All books',
          });

          if (showBookLink) {
            crumbs.push({
              href: route('admin.book.view', this.book),
              title: this.book?.title,
            });

            if (showPromoLink) {
              crumbs.push({
                href: route('admin.promo.view', this.promo),
                title: this.promo?.name,
              });
            } else if (showPromoBackLink) {
              crumbs.push({
                href: route('admin.promos', { b: this.book.id }),
                title: `Book promos`,
              });
            } else if (hasPromo) {
              crumbs.push({
                title: this.promo.name,
              });
            }
          } else {
            crumbs.push({
              title: this.book?.title,
            });
          }
        }
        return crumbs;
      },
    },

    mounted() {
      this.$nextTick(() => {
        if (!this.book && this.hasBookParams && this.$page.props?.books?.length) {
          this.book = this.$page.props.books.find((b) => b.id == route().params.b);
        }
      });
    },
  };
</script>

<!-- <style lang="scss" src="./BreadcrumbsNav.scss" scoped></style> -->
